import { callFunction } from "./functions-client";

// Automation rules (LOS Phase 18). MVP: `contact_created → add_task`.
export const AUTOMATION_TRIGGERS = ["contact_created"] as const;
export const AUTOMATION_ACTIONS = ["add_task"] as const;

export interface AddTaskConfig {
  contact_type?: string | null;
  task_title: string;
  due_in_days?: number;
}

export interface AutomationRule {
  id: string;
  name: string;
  trigger: string;
  action: string;
  config: AddTaskConfig;
  enabled: boolean;
  updated_at?: string;
  created_at?: string;
}

export const listRules = () =>
  callFunction<{ rules: AutomationRule[] }>("automation/list", { method: "GET" });

export const createRule = (input: { name: string; trigger: string; action: string; config: AddTaskConfig }) =>
  callFunction<{ rule: AutomationRule }>("automation/create", { body: input });

export const updateRule = (input: { id: string; name?: string; config?: AddTaskConfig; enabled?: boolean }) =>
  callFunction<{ ok: boolean }>("automation/update", { body: input });

export const setRuleEnabled = (id: string, enabled: boolean) =>
  callFunction<{ ok: boolean; enabled: boolean }>("automation/set-enabled", { body: { id, enabled } });

export const deleteRule = (id: string) =>
  callFunction<{ ok: boolean }>("automation/delete", { body: { id } });
